<div class="gift-page-container">

  <!-- Header Section -->
  <div class="back-color-header">
    <div class="back-color-header">
      <div [ngClass]="{'header-logo': isLogin}">
        <p class="title" routerLink="['/']">{{constants.WINDOW_SWAP_TXT}}</p>
        <app-user-menu *ngIf="isLogin" [from]="from"></app-user-menu>
    </div>
    </div>
    <div class="header-section">
      <div class="header-content">
        <p class="header-strong" #headerEl [attr.data-index]="1">{{constants.GIFT}}</p>
        <p class="header-strong" #headerEl [attr.data-index]="2">{{constants.WINDOW_SWAP_TXT}}</p>
        <p class="header-strong" #headerEl [attr.data-index]="3">{{constants.ALL_ACCESS}}</p>
        <p class="mt-16 trans" #headerEl [attr.data-index]="4">{{constants.GIVE_ALL_OF_WINDOW}}</p>
        <p class ="trans" #headerEl [attr.data-index]="4.5">{{constants.SOME_ONE_YOU_LOVE}}</p>
        <button class="cta-button trans" [routerLink]="'/giftCheckout'" #headerEl [attr.data-index]="5">{{constants.SEND_GIFT}}</button>
      </div>
      <div class="header-content-mobile">
        <p class="header-strong" #headerEl [attr.data-index]="0">{{constants.GIFT_WINDOWSWAP}}</p>
        <p class="header-strong" #headerEl [attr.data-index]="2">{{constants.ALL_ACCESS}}</p>
        <p class="trans" #headerEl [attr.data-index]="3">{{constants.GIVE_ALL_OF_WINDOWSWAP_LOVE}}</p>
        <div class="send-container trans" #headerEl [attr.data-index]="3"><button class="cta-button"
            [routerLink]="'/giftCheckout'">{{constants.SEND_GIFT}}</button></div>
      </div>
      <div class="header-image">
        <img [src]="constants.WS_GIFT_HOME" alt="Gift Illustration" />
      </div>
    </div>
  </div>
  <!-- Highlight Section -->
  <div class="highlight-section">
    <div class="highlight-left trans" #headerEl [attr.data-index]="isMobile ? 1 : 5">
      <div class="wrapper">
        <img [src]="constants.WS_NYT_LOGO" alt="Wirecutter Logo" />
        <p>{{constants.BEST_GIFTS_FOR}}</p>
        <p>{{constants.FREQUENT_TRAVELERS}}</p>
      </div>
    </div>
    <div class="highlight-content trans" #headerEl [attr.data-index]="isMobile ? 1 : 5">
      <p>{{constants.SOME_TIMES_TEXT}}</p>
      <p >{{constants.WORLD_LARGER_TEXT}}</p>
      <p>{{constants.ACESSIBLE_TEXT}}</p>
      <p class="city-strong">{{constants.NYT_WIRECUTTER}}</p>
      <button class="cta-button" [routerLink]="'/giftCheckout'">{{constants.GIFT_WINDOWSWAP}}</button>
    </div>
    <div class="highlight-content-mobile trans" #headerEl [attr.data-index]="1">
      <p>{{constants.SOME_TIMES_TEXT_MOBILE}}</p>
      <p>{{constants.WORLD_LARGER_TEXT_MOBILE}}</p>
      <p>{{constants.ACESSIBLE_TEXT_MOBILE}}</p>
      <p class="city-strong">{{constants.NYT_WIRECUTTER}}</p>
      <div class="send-container"><button class="cta-button"
          [routerLink]="'/giftCheckout'">{{constants.GIFT_WINDOWSWAP}}</button></div>
    </div>
  </div>

  <!-- Features Section -->
   <div class="features-wrapper">
  <div class="features-section">
    <div class="feature" #featureEl [attr.data-index]="1">
      <img [src]="constants.WS_GALLERY" alt="Gift Focus Illustration" class="gallery" />
      <p class="feature-heading">{{constants.GIFT_SOME_FOCUS}}</p>
      <p class="feature-sub-text" [innerHtml]="constants.THOUSANDS_TEXT"></p>
    </div>
    <div class="feature" #featureEl [attr.data-index]="isMobile ? 1 : 3">
      <img [src]="constants.WS_FAV" alt="Calm Place Illustration" class="fav" />
      <p class="feature-heading">{{constants.CALMEST_PLACE}}</p>
      <p class="feature-sub-text" [innerHtml]="constants.COMMUNITY_LIVES"></p>
    </div>
    <div class="feature" #featureEl [attr.data-index]="isMobile ? 1 : 5">
      <img [src]="constants.LOCATION_ALERT_IMG" alt="Travel Illustration" class="marker" />
      <p class="feature-heading">{{constants.TRAVEL_WORLD}}</p>
      <p class="feature-sub-text" [innerHtml]="constants.EVERY_DAY_SIDES"></p>
      <button class="cta-button-mobile" [routerLink]="'/giftCheckout'">{{constants.SEND_GIFT}}</button>
    </div>
  </div>
  <button class="cta-button" [routerLink]="'/giftCheckout'">{{constants.SEND_GIFT}}</button>
  
</div>

  <!-- Footer Section -->
  <footer class="footer-section">
    <a [href]="constants.INSTAGRAM_LINK" target="_blank" class="footer-link"><img [src]="constants.WS_INSTA_GIFTING"
        class="instagram" /></a>
    <a [routerLink]="['/blog']" target="_blank" class="footer-link"><img [src]="constants.WS_NEWS_GIFTING"
        class="latest-news" /></a>
    <a href="https://windowswapblog.squarespace.com/contact" target="_blank" class="footer-link"><img
        [src]="constants.WS_CONTACT_GIFTING" class="contact" /></a>
    <a [href]="constants.TERMS_CONDITIONS_LINK" class="footer-link"><img [src]="constants.WS_TERMS_GIFTING"
        class="terms" /></a>
  </footer>
</div>